/**
 * this handling of creating loading, toast
 */
import { Injectable } from '@angular/core';
import { RemoteDataService } from '@app/services/remote-data.service';
import { StorageService } from '@app/services/storage.service';
import { mergeMap } from 'rxjs/operators';
import { ShiftStatus } from '@app/interfaces/booking';


 @Injectable({
     providedIn: 'root',
 })
 export class ManageBookingsUtils {

  constructor(private remoteDataService: RemoteDataService,
              private storageService: StorageService) { }

    /**
     * get shift status
     * @param mobileNumber user mobile number
     * @param securityPin user security pin
     * @param deviceDetail user device detail
     * @param env user environment
     */
  getSiteInfoAndShiftStatus(mobileNumber, securityPin, deviceDetail, env) {
    let sitePrefixList = [];
    let siteInfoData = [];
    const shiftStatusResult = [];
    const deviceUUID = deviceDetail.uuid;
    // get siteInfo and shift status list
    this.remoteDataService.siteInfo({
      mobileNumber, 
      deviceUUID,
      pin: securityPin}, env)
      .pipe(mergeMap((siteInfo: any) => {
        siteInfoData = siteInfo;
        sitePrefixList = siteInfo.map(site => site.sitePrefix);
        // update site info global variable
        const manageBookingEnabled = siteInfo?.find(site => site.manageBookings.length > 0);
        if (manageBookingEnabled) {
          // sync workflow request for manage booking if manageBookings is enabled
          this.remoteDataService.workflowRequestSync({mobileNumber, deviceUUID, pin: securityPin}, env).subscribe();
        }
        const postData = {
          mobileNumber,
          pin: securityPin,
          deviceUUID: deviceDetail.uuid,
          sitePrefixList
        };
        // get shiftStatus offSite
        return this.remoteDataService.getShiftStatus(postData, env);
      }),
      mergeMap((shiftStatusList: Array<ShiftStatus>) => {
        // map shiftStatus with shift status description
        shiftStatusList.forEach((shiftStatus) => {
          const shiftList = shiftStatus.shiftStatusList.map((status) => {
            return status.Description;
          });
          shiftStatusResult.push({
            sitePrefix: shiftStatus.sitePrefix,
            offSite: shiftList
          });
        });
        const postData = {
          mobileNumber,
          pin: securityPin,
          deviceUUID: deviceDetail.uuid,
          sitePrefixList,
          onSite: true,
        };
        // get shiftStatus onSite
        return this.remoteDataService.getShiftStatus(postData);
      })
    ).subscribe(async (shiftStatusList: Array<ShiftStatus>) => {
      const siteList = [];
      shiftStatusList.forEach((shiftStatus, index) => {
        siteList.push(shiftStatus.sitePrefix);
        const shiftList = shiftStatus.shiftStatusList.map((status) => {
          return status.Description;
        });
        shiftStatusResult[index].onSite = shiftList;
      });
      siteInfoData = siteInfoData.filter((site) => siteList.includes(site.sitePrefix));
      await this.storageService.setLocal(siteInfoData, 'siteInfo');
      this.storageService.shiftStatus.next(shiftStatusResult);
    });
  }
}
